import React from 'react';
import c from 'classnames';
import classNames from 'classnames';
import './index.scss';

type SensorControlBoxProps = {
  isListItem?: boolean;
  value?: number | string | null;
  unit?: string;
  unitAsDegree?: boolean;
  details?: boolean;
  children?: React.ReactNode;
  padding?: string;
};

export const SensorControlBox: React.FC<SensorControlBoxProps> = ({
  isListItem,
  value,
  unit,
  unitAsDegree = false,
  details = false,
  children,
  padding,
}) => {
  return (
    <div
      className={c('sensor-control-box', {
        'sensor-control-box--list-view': isListItem,
        'sensor-control-box--details': details,
      })}
      {...(padding && { style: { padding } })}
    >
      {children ? (
        <>{children}</>
      ) : (
        <div className="sensor-control-box__value-wrapper">
          <span className="sensor-control-box__value">{value !== null ? value : '-'}</span>
          <span
            className={classNames('sensor-control-box__unit', {
              'sensor-control-box__unit--degree': unitAsDegree,
            })}
          >
            {unit}
          </span>
        </div>
      )}
    </div>
  );
};
